import * as ReportCorporateActions from './action';
const initialState = {
    reportDetails: [],
    reportDetailsFailure: [],
    scoreData: [],
    scoreDataFailure: [],
    riskGradeData: [],
    riskGradeDataFailure: [],
    dataCheck: [],
    dataCheckFailure: [],
    reportListResponse: [],
    sectionListResponse: [],
    sectionPdf:[],
    reportPdf:[],
    bprStatusSuccess: [],
    bprStatusFailure: [],
}
const reportCorporateReducer = (state = initialState, action) => {
    switch (action.type) {
        case ReportCorporateActions.FETCH_REPORT_DETAILS_SUCCESS:
            return state = {
                ...state,
                reportDetails: action.data
            }
        case ReportCorporateActions.FETCH_REPORT_DETAILS_FAILURE:
            return state = {
                ...state,
                reportDetailsFailure: action.data
            }
        case ReportCorporateActions.FETCH_PAYMENT_SCORE_SUCCESS:
            return state = {
                ...state,
                scoreData: action.data
            }
        case ReportCorporateActions.FETCH_PAYMENT_SCORE_FAILURE:
            return state = {
                ...state,
                scoreDataFailure: action.data
            }
        case ReportCorporateActions.FETCH_CUG_SCORE_SUCCESS:
            return state = {
                ...state,
                scoreData: action.data
            }
        case ReportCorporateActions.FETCH_CUG_SCORE_FAILURE:
            return state = {
                ...state,
                scoreDataFailure: action.data
            }
        case ReportCorporateActions.FETCH_PAYMENT_RISKGRADES_SUCCESS:
            return state = {
                ...state,
                riskGradeData: action.data
            }
        case ReportCorporateActions.FETCH_PAYMENT_RISKGRADES_FAILURE:
            return state = {
                ...state,
                riskGradeDataFailure: action.data
            }
        case ReportCorporateActions.DATA_CHECK_SUCCESS:
            return state = {
                ...state,
                dataCheck: action.data
            }
        case ReportCorporateActions.DATA_CHECK_FAILURE:
            return state = {
                ...state,
                dataCheckFailure: action.data
            }
        case ReportCorporateActions.FETCH_REPORT_LIST_RESPONSE:
            return state = {
                ...state,
                reportListResponse: action.data
            }
        case ReportCorporateActions.GET_SECTION_SUCCESS:
            return state = {
                ...state,
                sectionListResponse: action.data
            }   
        case ReportCorporateActions.GET_SECTION_FAILURE:
            return state = {
                ...state,
                sectionListResponse: action.data
            } 
        case ReportCorporateActions.SHOW_SECTION_PDF_SUCCESS:
            return state = {
                ...state,
                sectionPdf: action.data
            }   
        case ReportCorporateActions.SHOW_SECTION_PDF_FAILURE:
            return state = {
                ...state,
                sectionPdf: action.data
            }    
        case ReportCorporateActions.DOWNLOAD_REPORT_PDF_SUCCESS:
            return state = {
                ...state,
                reportPdf: action.data
            }   
        case ReportCorporateActions.DOWNLOAD_REPORT_PDF_FAILURE:
            return state = {
                ...state,
                reportPdf: action.data
            }   
        case ReportCorporateActions.BPR_STATUS_SUCCESS:
            return state = {
                ...state,
                bprStatusSuccess: action.data
            }
        case ReportCorporateActions.BPR_STATUS_FAILURE:
            return state = {
                ...state,
                bprStatusFailure: action.data
            }            
        default: return state
    }
}
export default reportCorporateReducer;